import React, { useState } from 'react'
import * as api from '../../api/account'
import { Button, CheckTile, ErrorText, Field, SectionTitle, inputClass } from './ui'

// Opisy przeniesione do `api/account.js` — te same kafelki pokazuje formularz
// rejestracji i nie chcemy dwóch list, które można rozjechać.
const OPISY = api.USER_TYPE_DESCRIPTIONS

const ProfileSection = ({ profile, setProfile, setFlash }) => {
  const [form, setForm] = useState({
    first_name: profile.first_name || '',
    last_name: profile.last_name || '',
    user_types: profile.user_types || [],
    user_type_other: profile.user_type_other || '',
  })
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  // Gałąź pytania bierze się z rodzaju konta — tak samo jak przy rejestracji.
  // Rodzaj zmienia się w sekcji firmowej, nie tutaj, więc czytamy go tylko do odczytu.
  const prywatne = profile.account_type !== 'company'
  const typy = api.typyDlaKonta(prywatne ? 'private' : 'company')

  const toggleType = (value) => {
    setForm((f) => ({
      ...f,
      // Prywatny wybiera JEDNO: albo ma instalację, albo nie ma.
      user_types: prywatne
        ? [value]
        : f.user_types.includes(value)
          ? f.user_types.filter((v) => v !== value)
          : [...f.user_types, value],
    }))
  }

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    const res = await api.updateProfile(form)
    setBusy(false)
    if (!res.ok) { setError(res.error); return }
    setProfile(res.data)
    setFlash('Zapisano zmiany.')
  }

  const pokazOpis = form.user_types.includes('other')

  return (
    <form onSubmit={submit}>
      <SectionTitle hint="Te dane są opcjonalne. Wypełnij je, jeśli chcesz, żebyśmy lepiej dopasowywali podpowiedzi.">
        Dane i typ działalności
      </SectionTitle>

      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <Field label="Imię">
          <input type="text" className={inputClass} value={form.first_name} disabled={busy}
                 onChange={(e) => setForm((f) => ({ ...f, first_name: e.target.value }))} />
        </Field>
        <Field label="Nazwisko">
          <input type="text" className={inputClass} value={form.last_name} disabled={busy}
                 onChange={(e) => setForm((f) => ({ ...f, last_name: e.target.value }))} />
        </Field>
      </div>

      <div className="mb-4">
        <p className="text-sm font-medium text-gray-700 mb-3">Czym się zajmujesz?</p>
        {/* Lista zależy od rodzaju konta — ta sama zasada co przy rejestracji.
            Firma może wskazać kilka ról naraz (sprzedaje i montuje, hurtownia
            prowadzi też sklep); osoba prywatna odpowiada na jedno pytanie. */}
        <div className="grid sm:grid-cols-2 gap-2">
          {typy.map(({ value, label }) => (
            <CheckTile
              key={value}
              single={prywatne}
              checked={form.user_types.includes(value)}
              onChange={() => toggleType(value)}
              label={label}
              description={OPISY[value]}
            />
          ))}
        </div>
        {!prywatne && (
          <p className="text-xs text-gray-400 mt-2">Możesz zaznaczyć kilka odpowiedzi.</p>
        )}
      </div>

      {pokazOpis && (
        <div className="mb-4">
          {/* Tekst w nawiasach klamrowych, a nie w cudzysłowie atrybutu: zawiera
              polskie cudzysłowy, które w atrybucie JSX zamykałyby go przedwcześnie. */}
          <Field label="Opisz krótko" hint={'Bez tego „Inne” nic nam nie mówi.'}>
            <input type="text" className={inputClass} value={form.user_type_other} disabled={busy}
                   maxLength={120}
                   onChange={(e) => setForm((f) => ({ ...f, user_type_other: e.target.value }))} />
          </Field>
        </div>
      )}

      <ErrorText>{error}</ErrorText>

      <div className="mt-5">
        <Button type="submit" busy={busy}>Zapisz zmiany</Button>
      </div>
    </form>
  )
}

export default ProfileSection
